import { render, staticRenderFns } from "./PetmedPetsBreakdown.vue?vue&type=template&id=0c89fb8e&scoped=true&"
import script from "./PetmedPetsBreakdown.vue?vue&type=script&lang=js&"
export * from "./PetmedPetsBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PetmedPetsBreakdown.vue?vue&type=style&index=0&id=0c89fb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89fb8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VProgressCircular})
